module.exports = __webpack_public_path__ + "static/media/sound1.3313bd2d.mp3";